/**
 * messenger類型
 * @readonly
 * @enum {string}
 */
enum msg$ {
    /** 成功 */
    success = 'success',
    /** 資訊 */
    info = 'info',
    /** 警告 */
    warn = 'warn',
    /** 失敗 */
    error = 'error',
}
//const msg$ = Object.freeze(
//    {
//        success: 'success',
//        info: 'info',
//        warn: 'warn',
//        error: 'error'
//    }
//);
export default msg$;